export default __webpack_public_path__ + "static/media/peacemaker.89835f19.png";